// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"ff635daa","161":"b56c9ff4","177":"74e96c13","236":"2b6d616c","329":"2dca560f","416":"4dd75717","621":"a13fb4a1","774":"ea5fa245"}[chunkId] + ".chunk.js";
};